// extracted by mini-css-extract-plugin
export default {"add-project-form-container":"AddProjectForm_add-project-form-container__amMxP","add-project-form-buttons-container":"AddProjectForm_add-project-form-buttons-container__j3yUM"};